import { getPriceChipLabel } from '@/features/catalog/price-filter'

import { FilterProperties } from '@/entities/catalog-old'

import { ApplyFilter } from '../types/types'

export const appliedFiltersAdapter = (properties: FilterProperties[]): ApplyFilter[] =>
	properties?.reduce((acc, obj) => {
		if (obj.CODE === 'PRICE') {
			const checkedValues = obj.VALUES.filter(v => v.CHECKED)

			if (checkedValues.length > 0) {
				const from = checkedValues[0]?.FILTERED_VALUE ?? checkedValues[0]?.VALUE
				const to = checkedValues[1]?.FILTERED_VALUE ?? checkedValues[1]?.VALUE

				acc.push({
					name: obj.NAME,
					code: obj.CODE,
					displayType: obj.DISPLAY_TYPE,
					id: 'PRICE',
					value: getPriceChipLabel(from != null ? String(from) : undefined, to != null ? String(to) : undefined)
				})
			}

			return acc
		}

		// Mirror the sidebar filter: its checkboxes are `disabled` when ELEMENT_COUNT === 0, so such a
		// value — checked but no longer yielding any products under the other active filters — is NOT
		// submitted and gets dropped. The applied chips rebuild the filter the same way, otherwise keeping
		// a zero-count value would emit an empty (0-product) combination whose URL 404s (e.g. unchecking
		// one of two «Тип» values leaves the other one that now matches nothing).
		const checkedValues = obj.VALUES.filter(val => val.CHECKED && val.ELEMENT_COUNT > 0)

		if (checkedValues.length) {
			checkedValues.forEach(({ VALUE, ID, FILTERED_VALUE }) =>
				acc.push({
					name: obj.NAME,
					code: obj.CODE,
					displayType: obj.DISPLAY_TYPE,
					id: ID,
					value: FILTERED_VALUE || VALUE
				})
			)
		}

		return acc
	}, [])
